import { render } from "./TokenListsListItem.vue?vue&type=template&id=1704a47a&ts=true"
import script from "./TokenListsListItem.vue?vue&type=script&lang=ts"
export * from "./TokenListsListItem.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__